import React from 'react';

export default function AccomplishmentsSection() {
  const accomplishmentsData = [
    {
      category: 'Academic Achievements',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M22 10v6M2 10l10-5 10 5-10 5z"/>
          <path d="M6 12v5c0 2 3 3 6 3s6-1 6-3v-5"/>
        </svg>
      ),
      items: [
        { label: '1 Time Dean\'s Lister', value: 'Achieved academic excellence for one semester.' },
        { label: 'High Grades in Major Subjects', value: 'Excellence in algorithms, embedded systems, and advanced web development.' }
      ]
    },
    {
      category: 'BPI Hackathon',
      date: '2024',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <polyline points="16 18 22 12 16 6"/>
          <polyline points="8 6 2 12 8 18"/>
          <line x1="14" y1="4" x2="10" y2="20"/>
        </svg>
      ),
      subtitle: 'Team: The Owlgorithms | Track: Workplace Productivity & Future of Work',
      items: [
        { label: 'Project', value: 'AttriSense: Turning Data Into Care — a predictive analytics and decision intelligence platform that uses machine learning (XGBoost, Random Forest) and Explainable AI (SHAP) to help BPO operations proactively reduce employee attrition and burnout. The system generates risk scores, transparent explanations, and personalized HR interventions through an interactive Streamlit dashboard.' }
      ]
    },
    {
      category: 'CpElympics',
      date: '2025',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="8" r="7"/>
          <polyline points="8.21 13.89 7 23 12 20 17 23 15.79 13.88"/>
        </svg>
      ),
      subtitle: 'Annual Computer Engineering Olympics',
      items: [
        { label: '2025', value: 'Larong Pinoy 2nd runner up' }
      ]
    },
    {
      category: 'ECup',
      date: '2023 - 2025',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"/>
          <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"/>
          <path d="M4 22h16"/>
          <path d="M10 22V2h4v20"/>
          <rect x="6" y="2" width="12" height="7" rx="1"/>
        </svg>
      ),
      subtitle: 'Engineering Cup Competition',
      items: [
        { label: '2023', value: 'Rubik\'s Cube 1st runner up' },
        { label: '2024', value: 'Rubik\'s Cube 1st runner up, CODM champion' },
        { label: '2025', value: 'Rubik\'s Cube champion, CODM champion, Bato Bata 1st runner up' }
      ]
    },
    {
      category: 'Brovolution',
      date: '2023 - 2025',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      subtitle: 'School Sportsfest',
      items: [
        { label: '2023', value: 'Reserve Rubik\'s Cube' },
        { label: '2024', value: 'Reserve CODM, Rubik\'s Cube 1st runner up' },
        { label: '2025', value: 'Reserve Chess, Rubik\'s Cube 2nd runner up' }
      ]
    },
    {
      category: 'Leadership & Organization',
      date: 'Present',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
          <circle cx="9" cy="7" r="4"/>
          <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
          <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
        </svg>
      ),
      subtitle: 'Institute of Computer Engineers of the Philippines - FAITH Chapter (ICpEP.SE)',
      items: [
        { label: 'Officer', value: 'Actively involved in planning and facilitating enhancement and academic activities for computer engineering students, helping organize seminars, workshops, and technical events that strengthen both technical skills and professional development within the chapter.' }
      ]
    },
    {
      category: 'Collaborative Project Presentation',
      date: '2026',
      icon: (
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <rect x="2" y="3" width="20" height="14" rx="2" ry="2"/>
          <line x1="8" y1="21" x2="16" y2="21"/>
          <line x1="12" y1="17" x2="12" y2="21"/>
          <path d="M7 7h10"/>
          <path d="M7 11h10"/>
        </svg>
      ),
      subtitle: 'Prototype Exhibition',
      items: [
        { label: 'Best Research Prototype', value: 'Presented collaborative research project and prototype at the 2026 exhibition, recognized for outstanding innovation, technical implementation, and practical application.' }
      ]
    }
  ];

  return (
    <section id="accomplishments" className="section">
      <div className="section-content">
        <h2 className="section-title">Accomplishments</h2>
        <p style={{ marginBottom: '3rem', fontSize: '1.05rem', opacity: '0.9', maxWidth: '800px' }}>
          Academic achievements, competitions, and leadership roles that shaped my journey.
        </p>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '2rem', marginTop: '3rem' }}>
          {accomplishmentsData.map((accomplishment, index) => (
            <div 
              key={index}
              className="glass-card"
              style={{ 
                padding: '0',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'stretch',
                transition: 'all 0.3s ease',
                position: 'relative'
              }}
            >
              {/* Left Panel - Icon */}
              <div style={{ 
                flex: '0 0 340px',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                background: 'linear-gradient(135deg, rgba(255, 255, 255, 0.03) 0%, rgba(255, 255, 255, 0.06) 100%)',
                borderRight: '1px solid var(--glass-border)',
                padding: '3rem 2rem',
                position: 'relative'
              }}>
                {/* Vertical Accent Bar */}
                <div style={{
                  position: 'absolute',
                  left: 0,
                  top: '20%',
                  bottom: '20%',
                  width: '5px',
                  background: 'var(--primary)',
                  borderRadius: '0 4px 4px 0',
                  boxShadow: '0 0 20px var(--primary)'
                }}></div>

                {/* Icon Container */}
                <div style={{
                  width: '160px',
                  height: '160px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '20px',
                  border: '2px solid var(--glass-border)',
                  padding: '2rem',
                  boxShadow: '0 10px 30px rgba(0, 0, 0, 0.3), inset 0 1px 0 rgba(255, 255, 255, 0.1)',
                  color: 'var(--primary)'
                }}>
                  {accomplishment.icon}
                </div>

                {/* Date Badge */}
                {accomplishment.date && (
                  <div style={{
                    marginTop: '1.5rem',
                    padding: '0.7rem 1.5rem',
                    background: 'linear-gradient(135deg, rgba(var(--primary-rgb, 99, 102, 241), 0.15) 0%, rgba(var(--primary-rgb, 99, 102, 241), 0.05) 100%)',
                    border: '1.5px solid var(--primary)',
                    borderRadius: '30px',
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.6rem',
                    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.2)'
                  }}>
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="var(--primary)" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"/>
                      <line x1="16" y1="2" x2="16" y2="6"/>
                      <line x1="8" y1="2" x2="8" y2="6"/>
                      <line x1="3" y1="10" x2="21" y2="10"/>
                    </svg>
                    <span style={{
                      color: 'var(--primary)',
                      fontWeight: '700',
                      fontSize: '0.95rem',
                      letterSpacing: '0.5px'
                    }}>
                      {accomplishment.date}
                    </span>
                  </div>
                )}
              </div>

              {/* Right Panel - Details */}
              <div style={{ 
                flex: '1',
                padding: '3rem 3.5rem',
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                background: 'rgba(0, 0, 0, 0.15)',
                minHeight: '300px'
              }}>
                {/* Category Information */}
                <div style={{ marginBottom: '2.5rem' }}>
                  <h3 style={{ 
                    fontSize: '1.75rem', 
                    marginBottom: '1rem',
                    color: 'var(--text)',
                    lineHeight: '1.3',
                    fontWeight: '700',
                    letterSpacing: '-0.5px'
                  }}>
                    {accomplishment.category}
                  </h3>
                  
                  {/* Subtitle */}
                  {accomplishment.subtitle && (
                    <div style={{ 
                      display: 'flex', 
                      alignItems: 'flex-start', 
                      gap: '0.75rem',
                      padding: '1rem 0',
                      borderBottom: '2px solid var(--glass-border)'
                    }}>
                      <p style={{ 
                        color: 'var(--text)', 
                        fontWeight: '600',
                        fontSize: '1.05rem',
                        margin: 0,
                        lineHeight: '1.5',
                        opacity: '0.9'
                      }}>
                        {accomplishment.subtitle}
                      </p>
                    </div>
                  )}
                </div>

                {/* Items */}
                <div style={{ 
                  display: 'flex',
                  flexDirection: 'column',
                  gap: '1.5rem'
                }}>
                  {accomplishment.items.map((item, idx) => (
                    <div 
                      key={idx} 
                      style={{ 
                        display: 'flex',
                        gap: '1rem',
                        alignItems: 'flex-start',
                        padding: '1rem 1.25rem',
                        background: 'rgba(255, 255, 255, 0.03)',
                        borderRadius: '10px',
                        border: '1px solid var(--glass-border)',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.06)';
                        e.currentTarget.style.borderColor = 'var(--primary)';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = 'rgba(255, 255, 255, 0.03)';
                        e.currentTarget.style.borderColor = 'var(--glass-border)';
                      }}
                    >
                      {/* Icon Indicator */}
                      <div style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: 'var(--primary)',
                        marginTop: '8px',
                        flexShrink: 0,
                        boxShadow: '0 0 10px var(--primary)'
                      }}></div>
                      
                      <div style={{ flex: 1 }}>
                        <span style={{ 
                          color: 'var(--primary)', 
                          fontWeight: '700',
                          fontSize: '0.8rem',
                          textTransform: 'uppercase',
                          letterSpacing: '1.2px',
                          display: 'block',
                          marginBottom: '0.5rem'
                        }}>
                          {item.label}
                        </span>
                        <span style={{ 
                          color: 'var(--muted)', 
                          fontSize: '1rem',
                          lineHeight: '1.7',
                          display: 'block'
                        }}>
                          {item.value}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Responsive Styles */}
        <style>{`
          @media (max-width: 1024px) {
            .glass-card > div:first-child {
              flex: 0 0 100% !important;
              border-right: none !important;
              border-bottom: 1px solid var(--glass-border) !important;
              padding: 2.5rem 2rem !important;
            }
            .glass-card > div:last-child {
              padding: 2.5rem 2rem !important;
            }
            .glass-card {
              flex-direction: column !important;
            }
          }
        `}</style>

      </div>
    </section>
  );
}
